import {ProductPropertiesPane} from '../components/NodePropertiesPane.jsx'
import LongText from '../../SidePanel/RightPanel/PropertiesControllerLongText.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
import Ls from '../LS/PropertiesControllerLs.jsx'
import Model from './ModelLsi.mjs'

const PropertiesPaneLsi = (props) => (
    <ProductPropertiesPane
        controllers={
            <>
                <Ls />
                <Text prop="lsiNo" />
                <Text prop="lsiName" />
                <Text prop="reqProtocol" />
                <Text prop="reqType" />
                <LongText prop="reqUrl" />
                <LongText prop="memo" />
            </>
        }

        Model={Model}

        snSuffix={
            <Analyse
                modes={[
                    'ChgReferenceSingle',
                    //'Depend',
                    'Effect',
                    'Reference',
                    'ReferenceCall',
                    'IsrfReference',
                ]}
            />
        }

        {...props}
    />
)

export default PropertiesPaneLsi
